<template>
    <div v-loading="isLoadingSetting || isLoadingPlaces">
        <!-- Add New Location Button -->
        <el-row>
            <el-col :span="24">
                <!-- Button: open the Place modal -->
                <el-button
                        type="primary"
                        icon="el-icon-plus"
                        @click="handleOpenPlaceModal(null)"
                        v-if="settingHasAccess"
                >
                    Add
                </el-button>
                <!-- Place Modal -->
                <el-dialog
                    :title="placeModalTitle"
                    :visible.sync="showPlaceModal"
                    top="10vh"
                    @closed="handleClosedPlaceModal"
                >
                    <el-form
                            v-if="showPlaceForm"
                            ref="form"
                            :model="form"
                            label-width="120px"
                            :rules="rules"
                    >
                        <el-form-item label="Name" prop="name">
                            <el-input
                                    v-model="form.name"
                                    placeholder="Please enter the name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Address" prop="addressReadable">
                            <el-autocomplete
                                    v-model="form.addressReadable"
                                    :fetch-suggestions="querySearchAsync"
                                    placeholder="Please enter the address"
                                    @select="handleSelect"
                                    value-key="FullAddress"
                                    style="width: 100%;"
                                    :trigger-on-focus="false"
                                    :debounce="800"
                            ></el-autocomplete>
                        </el-form-item>
                        <el-form-item label="Latitude" v-show="showLatLng" prop="lat">
                            <el-input v-model="form.lat"></el-input>
                        </el-form-item>
                        <el-form-item label="Longitude" v-show="showLatLng" prop="lng">
                            <el-input v-model="form.lng"></el-input>
                        </el-form-item>
                        <!--Google Map-->
                        <el-form-item>
                            <div>
                                <small class="text-muted">Drag the marker if it's not placed correctly.</small>
                                <Gmap-Map
                                        v-loading="isLoadingNzPostObj"
                                        @click="mapClicked"
                                        style="width: 100%; height: 350px;"
                                        :zoom="map.zoom"
                                        :center="{
                                            lat: this.map.center.lat,
                                            lng: this.map.center.lng
                                        }"
                                        map-type-id="satellite">
                                    <Gmap-Marker
                                            v-if="this.form.lat && this.form.lng"
                                            :position="{
                                                lat: this.form.lat,
                                                lng: this.form.lng,
                                            }"
                                            :draggable="true"
                                            @dragend="handleDragEnd"
                                    ></Gmap-Marker>
                                </Gmap-Map>
                            </div>
                        </el-form-item>
                        <!--Footer Buttons-->
                        <el-form-item>
                            <el-button v-if="this.form.id !== ''" type="primary" @click="handleSubmit('form')" :loading="isUpdatingPlace" :disabled="isLoadingNzPostObj">Save</el-button>
                            <el-button v-else type="primary" @click="handleSubmit('form')" :loading="isAddingPlace" :disabled="isLoadingNzPostObj">Create</el-button>
                            <el-button @click="handleRest('form')">Reset</el-button>
                        </el-form-item>
                    </el-form>
                </el-dialog>
            </el-col>
        </el-row>
        <br/>
        <!-- Places Table -->
        <el-row>
            <el-col :span="24">
                <el-table
                        v-if="! isLoadingSetting"
                        style="width: 100%"
                        :data="carrierPlaces"
                        border
                        :default-sort = "{prop: 'name', order: 'ascending'}"
                >
                    <el-table-column
                            prop="name"
                            label="Name"
                            min-width="25%"
                            sortable
                    ></el-table-column>
                    <el-table-column
                            prop="addressReadable"
                            label="Address"
                            min-width="50%"
                    ></el-table-column>
                    <el-table-column
                            label="Action"
                            align="center"
                            min-width="25%"
                            v-if="settingHasAccess"
                    >
                        <template slot-scope="scope">
                            <el-button size="mini" type="text" @click="handleOpenPlaceModal(scope.row)">Edit</el-button>
                            <el-button size="mini" type="text" @click="handleDeletePlace(scope.row)">Delete</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <br/>
                <el-alert
                        v-if="! settingHasAccess"
                        :title="`Found something wrong? Please contact ${businessOwner} to update the information.`"
                        type="info"
                        show-icon>
                </el-alert>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        components: {
        },
        data () {
            const validateAddress = (rule, value, callback) => {
                if (value !== '' && this.form.lat !== '' && this.form.lng !== '') {
                    callback();
                } else {
                    callback(new Error('Please select an address from drop-down list'));
                }
            };
            const emptyForm = {
                id: '',
                name: '',
                lat: '',
                lng: '',
                addressReadable: '',
            };
            return {
                isLoadingNzPostObj: false,
                showPlaceModal: false,
                showPlaceForm: false,
                showLatLng: false,
                emptyForm,
                form: emptyForm,
                rules: {
                    name: [
                        { required: true, message: 'Please enter a name', trigger: 'blur' }
                    ],
                    addressReadable: [
                        { validator: validateAddress, trigger: 'submit' },
                        { required: true, message: 'Please enter an address', trigger: 'blur' }
                    ],
                    lat: [
                        { required: true, message: 'Please enter an address and confirm the marker on the map', trigger: 'change' }
                    ],
                    lng: [
                        { required: true, message: 'Please enter an address and confirm the marker on the map', trigger: 'change' }
                    ],
                }
            }
        },
        methods: {
            handleOpenPlaceModal(place = null) {
                if (place) {
                    this.form = {...place};
                } else {
                    this.form = {...this.emptyForm};
                }
                this.openPlaceModal();
            },
            handleClosedPlaceModal() {
               this.showPlaceForm = false;
            },
            openPlaceModal() {
                this.showPlaceModal = true;
                this.showPlaceForm = true;
            },
            closePlaceModal() {
                this.showPlaceModal = false;
            },
            handleDeletePlace(place) {
                this.$confirm(`Sure to delete ${place.name}?`, 'Confirm', {
                    type: 'warning',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = 'Deleting...';
                            this.deletePlace(place)
                                .catch(e => {
                                    console.log(e);
                                    this.$message.error('Failed to delete the place.');
                                }).then(() => {
                                    instance.confirmButtonLoading = false;
                                    done();
                            })
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    this.$message.success('Deleted the place successfully.')
                }).catch(() => {
                    //click cancel
                });
            },
            handleDragEnd(data) {
                this.form.lat = data.latLng.lat();
                this.form.lng = data.latLng.lng();
            },
            mapClicked(location) {
                if (!this.form.lat && !this.form.lng) {
                    this.form.lat = location.latLng.lat();
                    this.form.lng = location.latLng.lng();
                }
            },
            querySearchAsync(queryString, cb) {
                axios.get('/api/locations?q=' + queryString)
                    .then(response => {
                        cb(response.data);
                    });
            },
            handleSelect(item) {
                console.log('handleSelect', item);
                if (item.DPID) {
                    this.isLoadingNzPostObj = true;
                    axios.get('/api/location-details?dpid=' + item.DPID)
                        .then(response =>{
                            const nzPostObject = response.data[0];
                            this.form.lat = nzPostObject.NZGD2kCoord.coordinates[1];
                            this.form.lng = nzPostObject.NZGD2kCoord.coordinates[0];
                        }).catch(e => {
                            this.$message.error('Sorry, failed to get the address details from NZ Post API.')
                        }).then(() => {
                            this.isLoadingNzPostObj = false;
                            this.$refs['form'].validateField('addressReadable');
                        });
                }
            },
            handleSubmit (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        const data = {
                            id: this.form.id,
                            addressReadable: this.form.addressReadable,
                            coordinates: this.form.lat + ',' + this.form.lng,
                            name: this.form.name,
                        };
                        if (data.id) {
                            //update Place
                            this.$store.dispatch('updatePlace', data)
                                .then(() => {
                                    this.closePlaceModal();
                                    this.$message.success('Updated this place successfully.');
                                }).catch(e => {
                                    console.log(e);
                                    this.$message.error('Sorry, failed to update this place.');
                                });
                        } else {
                            //create Place
                            this.$store.dispatch('addPlace', data)
                                .then(() => {
                                    this.closePlaceModal();
                                    this.$message.success('Added this place successfully.');
                                }).catch(e => {
                                    console.log(e);
                                    this.$message.error('Sorry, failed to add this place.');
                                });
                        }
                    } else {
                        return false;
                    }
                });
            },
            handleRest(formName) {
                this.$refs[formName].resetFields();
            },
            loadPlaces () {
                this.$store.dispatch('loadPlaces')
                    .catch(() => {
                        this.$message.error('Sorry, failed to load your places');
                    });
            },
            deletePlace (place) {
                return this.$store.dispatch('deletePlace', place.id);
            },
            mapForm (form) {
                return {
                    id: form.id,
                    name: form.name,
                    addressReadable: form.address_readable,
                    coordinates: form.lat + ',' + form.lng,
                }
            },
        },
        mounted() {
            this.loadPlaces();
        },
        computed: {
            businessOwner() {
                return typeof window.Freighthub.business !== 'undefined' ? window.Freighthub.business.ownerName : 'Business Owner';
            },
            settingHasAccess () {
                return this.$store.getters.getIfSettingHasAccess;
            },
            isLoadingSetting () {
                return this.$store.getters.getTruckRunningSettingLoadStatus === 1;
            },
            isLoadingPlaces: function () {
                return this.$store.getters.getPlacesLoadStatus === 1;
            },
            carrierPlaces: function () {
                return this.$store.getters.getPlaces;
            },
            isAddingPlace: function () {
                return this.$store.getters.getPlaceAddStatus === 1;
            },
            isUpdatingPlace: function () {
                return this.$store.getters.getPlaceUpdateStatus === 1;
            },
            placeModalTitle: function () {
                if (this.form.id !== '') {
                    return `Edit Place ${this.form.name}`;
                } else {
                    return 'New Place';
                }
            },
            map() {
                if (this.form.lat !== '' && this.form.lng !== '') {
                    return {
                        zoom: 18,
                        center: {
                            lat: this.form.lat,
                            lng: this.form.lng
                        }
                    }
                } else {
                    return {
                        zoom: 5,
                        center: {
                            lat: -41.066377,
                            lng: 172.859782
                        }
                    }
                }
            },
        }
    }
</script>

<style scoped>
    >>> svg {
        vertical-align: unset;
    }
</style>